'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var colors = {
	primary: '#2D9EE0',
	success: '#72C0B9',
	warning: '#FACA00',
	danger: '#F44336',
	cloud: '#ECF5FD',
	midnight: '#36475E',
	violet: '#673AB7',
	purple: '#9C27B0',
	navy: '#3F51B5',
	teal: '#009688',
	green: '#4CAF50',
	orange: '#FF9800',
	orangeRed: '#FF5722'
};

var fonts = {
	regular: 'Heebo, sans-serif',
	medium: 'Heebo-Medium, sans-serif',
	bold: 'Heebo-Bold, sans-serif'
};

var styles = {
	boxShadow: '0 4px 23px 0 rgba(0,0,0,.14)'
};

exports.default = {
	colors: colors,
	fonts: fonts,
	styles: styles
};